// extracted by mini-css-extract-plugin
export default {"imageWrapper":"styles_imageWrapper__LJ5e2","image":"styles_image__6tmW+","dotsWrapper":"styles_dotsWrapper__dktdj","dot":"styles_dot__q4Jn2"};